import { Site } from "./site";

export class SiteDetail {
    id?: string;
    site?: Site;
    isCreationMode?: boolean;
    isEditMode?: boolean;
    isReadOnlyMode?: boolean;
    constructor(siteDetail?: SiteDetail) {
        this.id = siteDetail?.id;
        this.site = siteDetail?.site;
        this.isCreationMode = siteDetail?.isCreationMode || false;
        this.isEditMode = siteDetail?.isEditMode || false;
        this.isReadOnlyMode = siteDetail?.isReadOnlyMode || false;
    }
}
